import { render, staticRenderFns } from "./UpdateProductDialog.vue?vue&type=template&id=681dba36&scoped=true"
import script from "./UpdateProductDialog.vue?vue&type=script&lang=js"
export * from "./UpdateProductDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681dba36",
  null
  
)

export default component.exports